import React from 'react'

const OrgStatusMessage = () => {
  return (
    <div className="alert alert-warning" role='alert'>
      Your company’s account is currently restricted. This limits your ability to send new 
      referrals, but you can still access any existing projects that you may have. Please 
      contact your company’s administrator for additional information.
    </div>
  )
}

export default OrgStatusMessage
